<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('change_of_grade_admin')"
                        :isNewButton="false"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('change_of_grade_admin')"
                              :isNewButton="false"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
                <b-row>
                  <b-col cols="12" md="4">
                    <b-form-group :label="$t('semester')">
                      <semesters-selectbox
                          v-model="datatable.queryParams.filter.semester_id"
                      ></semesters-selectbox>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group :label="$t('student_id')">
                      <b-form-input
                          v-model="datatable.queryParams.filter.student_number"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                   <b-col cols="12" md="4">
                       <b-form-group :label="$t('teaching_staff')">
                           <staff-auto-complete
                               v-model="datatable.queryParams.filter.instructor_id"
                           ></staff-auto-complete>
                       </b-form-group>
                   </b-col>

                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                       :total="datatable.total" :queryParams="datatable.queryParams" :lineNumbers="false"
                       @on-page-change="onPageChange" @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable">
            </datatable>
        </app-layout>
    </div>
</template>
<script>
//Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
//Component
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import StaffAutoComplete from "@/components/interactive-fields/StaffAutoComplete";
//Other
import qs from 'qs'
//Service
import GradeChangeService from "@/services/GradeChangeService";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,

        DatatableFilter,
        Datatable,
        StaffAutoComplete
    },
    metaInfo() {
        return {
            title: this.$t('change_of_grade_admin')
        }
    },
    data() {
        return {
            formId: 0,
            form: {},
            formProcess:null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t("detail"),
                                class: "ri-edit-box-line",
                                permission: 'gradechange_show',
                                callback: (row) => {
                                    this.$router.push('/grade/change/' + row.id)
                                },
                            },
                        ]
                    },
                    {
                      label: this.$t('semester'),
                      field: 'semester_name',
                      sortable: false,
                    },
                  {
                    label: this.$t('student_id'),
                    field: 'student_number',
                    sortable: false,
                  },
                    {
                        label: this.$t('student_name'),
                        field: 'student_name',
                        sortable: false,
                    },
                    {
                        label: this.$t('student_surname'),
                        field: 'student_surname',
                        sortable: false,
                    },
                    {
                        label: this.$t('course_name'),
                        field: 'course_name',
                        sortable: false,
                    },
                    {
                        label: this.$t('letter_grade'),
                        field: 'letter_grade',
                        sortable: false,
                    },
                    {
                        label: this.$t('new_letter_grade'),
                        field: 'new_letter_grade',
                        sortable: false,
                    },
                    {
                        label: this.$t('reason'),
                        field: 'reason',
                        sortable: false,
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: 'id',
                    page: 1,
                    limit: 20
                }
            }
        }
    },
    methods: {
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            return GradeChangeService.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data
                    this.datatable.total = response.data.pagination.total
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        formClear() {
            this.formId = null
            this.formProcess = null
        },
    }
};
</script>

